import { Grid, TextField, Typography } from '@mui/material';
import { Field } from 'formik';
import { useTheme } from '@mui/material';

interface FormValues {
  name: string;
  description: string;
  address: string;
  host: string;
  ip: string;
  port: number;
  tenantId: string;
}

interface BasicInfoSectionProps {
  isSubmitting: boolean;
  touched: { [K in keyof FormValues]?: boolean };
  errors: { [K in keyof FormValues]?: string };
}

export function BasicInfoSection({ isSubmitting, touched, errors }: BasicInfoSectionProps) {
  const theme = useTheme();

  return (
    <>
      <Grid item xs={12}>
        <Typography fontWeight={600} fontSize={16} color={theme.palette.text.primary} mb={2}>
          Dados Básicos
        </Typography>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="Nome do Fabricante"
          name="name"
          required
          disabled={isSubmitting}
          error={!!(touched.name && errors.name)}
          helperText={touched.name && errors.name}
          placeholder="Ex: Acme Corp"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="Endereço"
          name="address"
          required
          disabled={isSubmitting}
          error={!!(touched.address && errors.address)}
          helperText={touched.address && errors.address}
          placeholder="Ex: 123 Main St, City, Country"
        />
      </Grid>

      <Grid item xs={12}>
        <Field
          as={TextField}
          fullWidth
          label="Descrição"
          name="description"
          required
          multiline
          rows={3}
          disabled={isSubmitting}
          error={!!(touched.description && errors.description)}
          helperText={touched.description && errors.description}
          placeholder="Ex: Leading manufacturer of security equipment"
        />
      </Grid>
    </>
  );
} 